import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { CORE_API_SUFFIX, dataFetch } from '../../axios/customAxios';

export interface OAuthBridgeHandoffResponse {
  continue_url: string;
}

export const useOAuthBridgeHandoff = () => useMutation<
  AxiosResponse<OAuthBridgeHandoffResponse>,
  unknown,
  { handoff: string }
>(
  (payload) => dataFetch.post<OAuthBridgeHandoffResponse>(
    `${CORE_API_SUFFIX}oauth-bridge/handoff`,
    payload,
  ),
);

export interface OAuthConsentDecisionResponse {
  continue_url?: string;
  denied?: boolean;
}

export const useOAuthConsentDecide = () => useMutation<
  AxiosResponse<OAuthConsentDecisionResponse>,
  unknown,
  { state: string; decision: 'approve' | 'deny' }
>(
  (payload) => dataFetch.post<OAuthConsentDecisionResponse>(
    `${CORE_API_SUFFIX}oauth/consent`,
    payload,
  ),
);
